var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.06842L13 2.06842C14 1.06842 16 1.06842 17 2.06842L18 3.06842C19 4.06842 19 6.06842 18 7.06842L13 12.0684C12 13.0684 10 13.0684 9 12.0684M9 16.0684L7 18.0684C6 19.0684 4 19.0684 3 18.0684L2 17.0684C1 16.0684 1 14.0684 2 13.0684L7 8.06842C8 7.06842 10 7.06842 11 8.06842",
    stroke: "#B7B7B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsCopyLink);
export default __webpack_public_path__ + "static/media/DetailsCopyLink.6d930bd2d5a57bf9fa7dcc284919fc5b.svg";
export { ForwardRef as ReactComponent };